<template>
  <page-outline :title="listTitle">
    <template slot="pageContent">
      <div class="listPage ml-3 mr-3">
        <!-- Bouton de rafraîchissement -->
        <b-row class="justify-content-start">
          <b-col cols="4" lg="2" xl="1">
            <back-button :returnUrl="returnUrl"></back-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button class="btnFilter"
              @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="2" xl="1" class="mb-5">
            <b-button class="btnFilter"
              :disabled="activateSpinner"
              @click="onRefresh()">
              <i class="fa-light fa-rotate-right fs-14px"></i>
            {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
          <b-col cols="4" lg="3" xl="2">
            <b-button variant="secondary"
              @click="actionAdd">
              <i class="fa-light fa-plus"></i>
              <span>{{$t('common.email.email_address_add')}}</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row class="justify-content-start align-items-center mb-5" :class="{'filter-item-section':true, 'd-none': !displayFilter}">
          <b-col sm="3" class="form-group">
          <!-- Filtre Name -->
            <form-write-group-label-input v-model="Name"
              :inputLabel="$t('common.email.email_address_name')"
              @input="applyFilter">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="3" class="form-group">
          <!-- Filtre Email -->
            <form-write-group-label-input v-model="Email"
              :inputLabel="$t('common.email.email_address')"
              @input="applyFilter">
            </form-write-group-label-input>
          </b-col>
          <!-- Boutons Effacer et Appliquer -->
          <b-col sm="2" class="d-flex justify-content-end">
            <b-button class="btn mr-3" size="sm"
              @click="clearFilterFields"
              :disabled="!Name && !Email">
              {{ $t('filter.clr_fltr_field') }}
            </b-button>
            <!-- <b-button class="btn" size="sm"
              @click="applyFilter">
              {{ $t('common.srch') }}
            </b-button> -->
          </b-col>
        </b-row>
        <b-row class="justify-content-center mb-5">
          <div>
            <spinner v-if="activateSpinner"></spinner>
            <b-table v-else-if="listItemsEmailAddress.length > 0"
              :items="listItemsEmailAddress"
              :fields="fields"
              :sort-by.sync="sortBy"
              class="table-striped"
              fixed
              hover
              :selectable="listItemsEmailAddress.length > 0"
              :empty-text="$t('common.security.no_result')"
              @row-selected="onRowSelected"
              :key="refreshKey">
              <template #cell(Name)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(Email)="data">
                <span>{{ data.value }}</span>
              </template>
              <template #cell(edit)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionEdit($event, data.item.IdEmailAddress)">
                  <i class="fa-regular fa-pencil"></i>
                </span>
              </template>
              <template #cell(delete)="data">
                <span class="text-center d-inline-block py-3 w-100" @click="actionDelete($event, data.item.IdEmailAddress)">
                  <i class="fa-regular fa-trash"></i>
                </span>
              </template>
            </b-table>
            <div v-else class="d-flex justify-content-center">
              <span class="noResult">
                {{ $t('common.no_result') }}
              </span>
            </div>
          </div>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import formWriteGroupLabelInput from "@/components/common/formWriteGroupLabelInput.vue"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import backButton from "@/components/common/backButton.vue"

export default {
  name: "EmailAddressPage",
  components: {
    'back-button': backButton,
    "form-write-group-label-input": formWriteGroupLabelInput,
    "page-outline": PageOutline,
    spinner: Spinner
  },
  props: {
    id: {
      type: String,
      default: "-1",
    },
  },
  data() {
    return {
      activateSpinner: false,
      displayFilter: false,
      listItemsEmailAddress: [],
      listTitle: "",
      Name: '',
      Email: '',
      refreshKey: false,
      returnUrl: '/email/emailGroup/-1',
      sortBy: 'Name'
    }
  },
  created() {
    this.activateSpinner = true

    const emailGroupId = this.$route.params.id

    this.getGroupName(emailGroupId).then(groupName => {
      this.listTitle = `${this.$i18n.t("common.email.email_address_list")} - ${groupName}`;
      this.getEmailAddress(emailGroupId);
    })
  },
  computed: {
    canDelete () {
      return true
    },
    canEdit () {
      return true
    },
    fields () {
      let fields = []

      // fields.push({
      //   key: 'IdEmailAddress',
      //   label: this.$t('IdAdd'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      fields.push({
        key: 'Name',
        label: this.$t('common.email.email_address_name'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      fields.push({
        key: 'Email',
        label: this.$t('common.email.email_address'),
        thClass: 'text-center table-condensed-ipad',
        tdClass: 'p-0 text-center w-100 p-2 py-3',
        sortable: true
      })
      // fields.push({
      //   key: 'IdEmailGroup',
      //   label: this.$t('IdGroup'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      // fields.push({
      //   key: 'GroupName',
      //   label: this.$t('common.email.group_name'),
      //   thClass: 'text-center table-condensed-ipad',
      //   tdClass: 'p-0 text-center w-100 p-2 py-3',
      //   sortable: true
      // })
      if (this.canEdit) {
        fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      if (this.canDelete) {
        fields.push({ key: 'delete', label: this.$t('rights.delete'), thClass: 'text-center table-condensed-ipad w-10', tdClass: 'p-0' })
      }
      return fields
    }
  },
  methods: {
    actionAdd () {
      const emailGroupId = this.$route.params.id
      loadPage(this, {url: '/email/emailAddress/add/-1' + '?groupId=' + emailGroupId })
    },
    actionDelete ($e, id) {
      $e.stopPropagation()
      let that = this
      const emailGroupId = this.$route.params.id
      this.$f7.modal({
        title: this.$t('common.email.element_deletion_confirm'),
        buttons: [
          {
            text: this.$t('creation_forms.vldt'),
            onClick: function () {
              let params = { id: id }
              that.$engine.firstOn().email.emailAddress.delete(params)
              .then(resp => {
                that.listItemsEmailAddress = that.listItemsEmailAddress.filter(item => item.IdEmailAddress !== id)
                that.$f7.modal({
                  title: that.$t('common.email.email_address_deleted'),
                  buttons: [
                    { text: 'OK', onClick: function () { return } }
                  ]
                })
                loadPage(that, { url: 'email/emailAddress/' + emailGroupId })
              })
              .catch(e => {
                errorMessageAlert(e, that, that.$i18n)
                that.okMessageBox(that.$t('common.email.email_address_delete_error'))
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () { return }
          }
        ]
      })
    },
    actionEdit ($e, id) {
      $e.stopPropagation()
      const emailGroupId = this.$route.params.id
      loadPage(this, { url: '/email/emailAddress/edit/' + id + '?groupId=' + emailGroupId })
    },
    applyFilter () {
      this.activateSpinner = true
      this.getEmailAddress()
    },
    clearFilterFields () {
      this.Name = ''
      this.Email = ''
      // this.applyFilter()
    },
    getEmailAddress (emailGroupId) {
      let that = this
      let params = { groupId: emailGroupId, Name: this.Name, Email: this.Email }
      this.$engine.firstOn().email.emailAddress.fetch(params).then((resp) => {
        let emailAddressList = {}

        emailAddressList = resp.data.EmailAddress || []

        for (let i = 0; i < emailAddressList.length; i++) {
          emailAddressList[i].delete = emailAddressList[i].IdEmailAddress
          emailAddressList[i].edit = emailAddressList[i].IdEmailAddress
        }

        that.updateEmailAddress(emailAddressList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getGroupName (emailGroupId) {
      let that = this
      return this.$engine.firstOn().email.emailGroup.fetch({ id: emailGroupId }).then(resp => {
        const group = resp.data.EmailGroup.find(group => group.IdEmailGroup === emailGroupId)
        return group ? group.GroupName : null
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    onRefresh () {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      const emailGroupId = this.$route.params.id
      this.getEmailAddress(emailGroupId)
    },
    onRowSelected (item) {
      if (item[0] && item[0].IdEmailAddress) {
        const emailGroupId = this.$route.params.id
        loadPage(this, { url: '/email/emailAddress/details/' + item[0].IdEmailAddress + '?groupId=' + emailGroupId })
      }
    },
    updateEmailAddress (emailAddressList) {
      this.listItemsEmailAddress = emailAddressList.filter(item => item.IdEmailGroup === this.$route.params.id)
    }
  }
}
</script>
